export default __webpack_public_path__ + "img/ts-home.3c36420b.jpg";